import { createGetPropGetter } from '@/store/utils';

export default {
  recalculationInProgress: createGetPropGetter('recalculationInProgress', []),
  passiveRiskScore: createGetPropGetter('passiveRiskScore', {}),
  projectStatistics: createGetPropGetter('projectStatistics', {}),
  cloudServicesStatistics: createGetPropGetter('cloudServicesStatistics', {}),
  generalStatistics: createGetPropGetter('generalStatistics', {}),
};
